__webpack_require__.p = "/mi-assets/mi-static/mi-legal-renderer/web-rel-26.7.2-ae02894-13680/_next/";